module.exports = __webpack_public_path__ + "img/product-placeholder-58.301ddb8.png";